$(document).ready(() => {
$('.class_checkin').click(function(){
  
    let itemid = $(this).data('itemid');
    let oid = $(this).data('oid');
    let stuid = $(this).data('stuid');
	let checkboxValue = $(this).is(":checked") ? 1 : 0

    $.ajax({
        url: roster_vars.ajaxurl,
        method: 'POST',
        data: {   
            action: "roster_ajax_receive",
			checked: checkboxValue,
			oid: oid,
   			itemid: itemid,
            stuid: stuid
		}
    }).done(function(response){
        $("#save-attend").fadeIn('fast');
        $('#save-attend').delay(1800).fadeOut('fast');
        console.log("Response: " + response);
    }).fail(function(error){
        console.log(error);
    });
});
})
